import { CurriculumGradeDataType } from '../types/curriculum.types'

const normalizeLevelId = (id: string): string => {
  if (/activity|how|why|definition/.test(id)) {
    return id.replace(/^[^#]+#/, '')
  }
  return id
}

export function generateUserCurriculumCompletedProgress(
  gradeData: CurriculumGradeDataType,
  curriculumProgressData: string[],
): CurriculumGradeDataType {
  const indexedIds = new Set(curriculumProgressData)

  const updatedGradeSubdivisions = gradeData.gradeSubdivisions.map((subdivision) => {
    const updatedSubjects = subdivision.subjects.map((subject) => {
      const updatedCompetencyGoals = subject.competencyGoals.map((competencyGoal) => {
        const updatedLevels = competencyGoal.levels.map((level) => {
          const processedId = level.levelIds.map(normalizeLevelId)
          return {
            ...level,
            isCompleted: processedId.every((id) => indexedIds.has(id)),
          }
        })
        const isCompetencyGoalCompleted = updatedLevels?.every((level) => level?.isCompleted)
        return {
          ...competencyGoal,
          levels: updatedLevels,
          isCompleted: isCompetencyGoalCompleted, // Add isCompleted to competencyGoal
        }
      })
      return {
        ...subject,
        competencyGoals: updatedCompetencyGoals,
      }
    })
    return {
      ...subdivision,
      subjects: updatedSubjects,
    }
  })

  return {
    ...gradeData,
    gradeSubdivisions: updatedGradeSubdivisions,
    progressIds: [...indexedIds],
  }
}
